(function() {

    'use strict';

    angular.module('app').
    controller('CarrierServiceProfileViewController', CarrierServiceProfileViewController);

    CarrierServiceProfileViewController.$inject = ['$location', '$filter', '$rootScope', '$scope', 'Carrier', 'CarrierCentreKgTableService', 'CarrierFlatRateTableService'];

    function CarrierServiceProfileViewController($location, $filter, $rootScope, $scope, Carrier, CarrierCentreKgTableService, CarrierFlatRateTableService) {
        var vm = this;

        init();

        function init() {
            var paginationData = {
                size: 5,
                page: 0,
                sort: 'clientId'
            };
            getCarrierServiceProfile(paginationData);
            vm.centrePerKg = CarrierCentreKgTableService;
        }

        function getCarrierServiceProfile(requestPagination, filters) {
            var requestData = {};
            angular.extend(requestData, requestPagination, filters);

            Carrier.getServiceProfile(function(data) {
                vm.profile = data;
                vm.flatRate    = CarrierFlatRateTableService.buildTableData(data, requestPagination);
                //console.log('data', data);
            }, function(err) {
                console.log(err);
            });
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/carriers/CarrierServiceProfileViewController.js